import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname.includes('/deck') || location.pathname.includes('/profile') || location.pathname.includes('/blog');

  return (
    <div className="min-h-screen flex flex-col bg-black pt-12">
      <Navbar />
      <main className={`flex-grow ${!isHomePage ? 'pt-12 md:pt-20' : ''}`}>
        <div className={`${!isHomePage ? 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8' : ''}`}>
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 